import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dbService from "../../firebase/dbService";
import { query, where } from "firebase/firestore";
import { participantsCollectionRef } from "../../config/firebaseConfig";

export const fetchSchoolParticipants = createAsyncThunk(
  "auth/fetchSchoolParticipants",
  async ({ schoolId }, { rejectWithValue }) => {
    const q = query(
      participantsCollectionRef,
      where("schoolDetails.schoolId", "==", schoolId)
    );
    try {
      const participants = await dbService.getDocsWithQuery(q);
      return participants;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  participants: [],
  loading: false,
  error: null,
};

export const schoolParticipantsSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchoolParticipants.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchoolParticipants.fulfilled, (state, action) => {
        state.loading = false;
        state.participants = action.payload;
        state.error = null;
      })
      .addCase(fetchSchoolParticipants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default schoolParticipantsSlice.reducer;
